export default "/images/email.svg?59a8a4ebd79b9534c54a485054a4cf89";